import {all, call, put, takeLatest} from "redux-saga/effects";
import queryString from "query-string";
import {toast} from "react-toastify";

import {getErrorMessage} from "utils/sagasErrorHandler";
import messageHelper from "utils/messages/messageHelper";

import {
    createQuotaLimits,
    deleteQuotaLimits,
    getQuotaLimits,
    getQuotaLimitsError,
    getQuotaLimitsSuccess,
    changeLimit,
    mergeLimitDialog,
    setQuotaManagerDialog,
    setLimitDialog
} from "modules/QuotaManager/services/QuotaLimits/actions";
import {
    getQuotaLimitsRequest,
    deleteQuotaLimitRequest,
    createQuotaLimitRequest,
    patchQuotaLimitRequest,
} from "modules/QuotaManager/services/QuotaLimits/api";

//Workers
function* handleRefreshList() {
    const {search} = window.location;
    yield put(getQuotaLimits(queryString.parse(search)));
}

function* handleGetQuotaLimits({payload}) {
    try {
        const {count, quota_limits} = yield call(getQuotaLimitsRequest, payload);

        yield put(getQuotaLimitsSuccess({
            quotaLimits: quota_limits,
            count
        }));
    } catch (error) {
        yield put(getQuotaLimitsError());
        getErrorMessage(error);
    }
}

function* handleCreateQuotaLimit({payload}) {
    try {
        yield call(createQuotaLimitRequest, payload);

        yield put(setQuotaManagerDialog());
        yield call(toast.success, "The quota limit has been successfully created");

        yield handleRefreshList();
    } catch (error) {
        getErrorMessage(error);
    }
}

function* handleDeleteQuotaLimits({payload}) {
    try {
        yield all(payload.map((payload) => call(deleteQuotaLimitRequest, payload)));
        messageHelper({
            type: "success",
            actionSubject: `Quota limit${payload.length > 1 ? "s" : ""} with id${payload.length > 1 ? "s" : ""} - ${payload.join(", ")}`,
            action: "deleted",
            plural: payload.length > 1
        });

        yield handleRefreshList();
    } catch (error) {
        getErrorMessage(error);
    }
}

function* handleChangeLimit ({ payload }) {
    try {
        yield put(mergeLimitDialog({ isLoading: true }));
        yield call(patchQuotaLimitRequest, payload);
        yield call(
            toast.success,
            `Quota limit has been successfully changed`
        );
        yield put(setLimitDialog());
        yield handleRefreshList();
    } catch (error) {
        yield put(mergeLimitDialog({ isLoading: false }));
        getErrorMessage(error);
    }
}

// Watchers
export function* quotaLimitsSagas() {
    yield all([
        yield takeLatest(getQuotaLimits, handleGetQuotaLimits),
        yield takeLatest(createQuotaLimits, handleCreateQuotaLimit),
        yield takeLatest(deleteQuotaLimits, handleDeleteQuotaLimits),
        yield takeLatest(changeLimit, handleChangeLimit),
    ]);
}
